



































































































































































































































import {Component} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import Provider1 from "@/content/1-start/UtilitiesSupport/Provider1.vue"
import Injected1 from "@/content/1-start/UtilitiesSupport/Injected1.vue"
import Provider2 from "@/content/1-start/UtilitiesSupport/Provider2.vue"
import ProviderMulti from "@/content/1-start/UtilitiesSupport/ProviderMulti.vue"
import InjectFunctional from "@/content/1-start/UtilitiesSupport/InjectFunctional.vue"
import InjectionPassthrough from "@/content/1-start/UtilitiesSupport/InjectionPassthrough.vue"
import JdiDoNot from "@/components/JdiDoNot.vue"


@Component({
    components: {
        JdiDoNot,
        InjectFunctional, InjectionPassthrough, ProviderMulti, Provider2, Injected1, Provider1,
        JdiPreview, JdiContent
    }
})
export default class Utilities extends Vue {
    injectDemo1 = 'injection 1';

    injectDemo2a = 'injection A';
    injectDemo2b = 'injection B';

    injectDemo3a = 'injection X';
    injectDemo3b = 'injection Y';
    injectDemo3c = 'injection K';
    injectDemo3d = 'injection J';

    injectDemoFunctional = 'functional injection';

}
